"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _CookiesCustomize = _interopRequireDefault(require("./components/CookiesCustomize"));
var _CookiesPopup = _interopRequireDefault(require("./components/CookiesPopup"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CookiesPopup = ({
  disableAnimation = false,
  showRejectAll
}) => {
  const {
    agreed
  } = (0, _cookies.useCookies)();
  const [customize, setCustomize] = React.useState(false);
  const handleOpenCustomize = React.useCallback(() => {
    setCustomize(true);
  }, []);
  const handleCloseCustomize = React.useCallback(() => {
    setCustomize(false);
  }, []);
  if (agreed !== null) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    id: "cookie_consent" // For ads/i-don't-care-about-cookies blockers
    ,
    "data-test": "CookiesPopup",
    children: [customize && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CookiesCustomize.default, {
      onClose: handleCloseCustomize
    }), !customize && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CookiesPopup.default, {
      onCustomize: handleOpenCustomize,
      disableAnimation: disableAnimation,
      showRejectAll: showRejectAll
    })]
  });
};
var _default = CookiesPopup;
exports.default = _default;